import { AppControllerStatusMethod } from '../methods/app-controller/status.method';

export class AppController {
  public readonly status = new AppControllerStatusMethod();
}
